import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header - Always on top */}
      <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Main content */}
      <div className="lg:pl-64" style={{ paddingTop: '64px', minHeight: 'calc(100vh - 64px)' }}>
        <main className="p-4 lg:p-6">
          {children}
        </main>
      </div>

      {/* Mobile sidebar overlay */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Desktop sidebar */}
      <div className="hidden lg:block lg:fixed lg:z-30 lg:w-64" style={{ top: '64px', left: '0', height: 'calc(100vh - 64px)' }}>
        <Sidebar />
      </div>

      
    </div>
  );
};

export default Layout; 